import { Immutable } from "immer";
import React from "react";

import { templates } from "@reactivated";

import { StreamField } from "@thelabnyc/thelabui/src/components/StreamField";

import { SidekickBlock } from "../../blocks/SidekickBlock";

/**
 * Component map for the pillows HomePage hero-sidekick assembly. Exported so
 * the block-screenshot styleguide harness renders through the same map
 * production uses (see ``StyleguideBlockTemplate.tsx``).
 */
export const homePageHeroSidekickComponentsMap = {
    hero_sidekick: SidekickBlock,
} as const;

/**
 * Pillows HomePage hero-sidekick assembly: dispatches the
 * ``HomePageHeroSidekickBlock`` StreamField to its React component, replacing
 * the legacy ``{% if self.hero_sidekick %}{{ self.hero_sidekick }}{% endif %}``
 * hydration root.
 */
export const HomePageHeroSidekick = (
    props: Immutable<{ page: templates.HomePageTemplate["page"] }>,
): React.JSX.Element | null => {
    if (!props.page.hero_sidekick) {
        return null;
    }
    return (
        <StreamField
            tagName={React.Fragment}
            value={props.page.hero_sidekick.value}
            components={homePageHeroSidekickComponentsMap}
        />
    );
};
